import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsMainComponent } from './tabs-main/tabs-main.component';
import { MyFlightsComponent } from './my-flights/my-flights.component';
import { CardTicketComponent } from './card-ticket/card-ticket.component';
import { NewReservationComponent } from './new-reservation/new-reservation.component';
import { FlightsFormComponent } from './flights-form/flights-form.component';
import { CardFlightComponent } from './card-flight/card-flight.component';
import { CardItineraryFlightComponent } from './card-itinerary-flight/card-itinerary-flight.component';
import { ChooseFlightComponent } from './choose-flight/choose-flight.component';
import { FlightConfirmationComponent } from './flight-confirmation/flight-confirmation.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SharedModule } from '../shared/shared.module';
import { FlightRoutingModule } from './flight-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CardItineraryFlightTwoComponent } from './card-itinerary-flight-two/card-itinerary-flight-two.component';
import { CardTicketMultiComponent } from './card-ticket-multi/card-ticket-multi.component';
import { CardTicketTripleComponent } from './card-ticket-triple/card-ticket-triple.component';
import { CardTicketCuadrupleComponent } from './card-ticket-cuadruple/card-ticket-cuadruple.component';
import { SeatAvailabilityComponent } from './seat-availability/seat-availability.component';

@NgModule({
  declarations: [
    TabsMainComponent,
    MyFlightsComponent,
    CardTicketComponent,
    NewReservationComponent,
    FlightsFormComponent,
    ChooseFlightComponent,
    CardFlightComponent,
    CardItineraryFlightComponent,
    FlightConfirmationComponent,
    CardItineraryFlightTwoComponent,
    CardTicketMultiComponent,
    CardTicketTripleComponent,
    CardTicketCuadrupleComponent,
    SeatAvailabilityComponent
  ],
  imports: [
    FlightRoutingModule,
    SharedModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTabsModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatCardModule,
    MatSlideToggleModule
  ],
  exports: [
    TabsMainComponent,
    MyFlightsComponent,
    NewReservationComponent
  ]

})
export class FlightModule { }
